export default function IsTouch($DOM, classes) {
	const is     = {};
	const _width = $DOM.win.width();

	is.Desktop = (_width > 1024) ? true : false; 
	is.Tablet  = (_width <= 1024 && _width) ? true : false;
	is.Mobile  = (_width <= 767) ? true : false;
	is.Touch   = ('ontouchstart' in window) ? true : false;

	$DOM.bodyTag.toggleClass(classes.IsTouch, is.Touch);

	return is;
}